import { render, staticRenderFns } from "./GoodDamageCategoriesForm.vue?vue&type=template&id=45a54427"
import script from "./GoodDamageCategoriesForm.vue?vue&type=script&lang=ts"
export * from "./GoodDamageCategoriesForm.vue?vue&type=script&lang=ts"
import style0 from "./GoodDamageCategoriesForm.vue?vue&type=style&index=0&id=45a54427&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports